module.exports = __webpack_public_path__ + "img/button_backooverview-Text.569f4ae6.svg";